import { getGenericEndpoint } from './get.api';
import type { GetRegisterAdditionalInfoResponse } from './types/get-register-additional-info.type';

export const getRegisterAdditionalInfo = async (lang?: string) => {
	return await getGenericEndpoint<GetRegisterAdditionalInfoResponse>(
		'register/additional-info',
		lang
	);
};
